import SharedNavbar from '../../components/feature/SharedNavbar';
import SharedFooter from '../../components/feature/SharedFooter';
import FloatingCallButton from '../../components/feature/FloatingCallButton';
import Hero from './components/Hero';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <Hero />
      <ContactForm />
      <MapSection />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}